import { render, staticRenderFns } from "./order.vue?vue&type=template&id=791f16ae&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"
import style0 from "./order.css?vue&type=style&index=0&id=791f16ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791f16ae",
  null
  
)

export default component.exports